<script lang="ts">
  import {modal} from '../stores/modal'
  import {fade} from 'svelte/transition'

  export let size: '' | 'tiny' | 'small' = ''
  export let scrolling = false
  export let close = true
</script>

<div class="ui modal visible active {size}" class:scrolling={scrolling} transition:fade={{duration: 500}}>
  {#if close}
    <span class="close icon-p-close" onclick={() => modal.close()}/>
  {/if}

  <slot/>
</div>

<style>
  .ui.modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>